import AppIcon from '@/images/app-icon.png?url'
import { Link } from '@tanstack/react-router'

import { Button } from './ui/button'

export default function NotFoundComponent() {
  return (
    <div className="flex h-dvh w-full flex-col">
      <main className="flex flex-1 flex-col items-center justify-center">
        <img
          src={AppIcon}
          alt="App Icon"
          className="mb-6 h-32 w-32 grayscale-80 invert-75"
        />
        <h1 className="mb-1 text-center text-xl font-semibold">
          Oops! An error occurred.
        </h1>
        <p className="text-muted-foreground mb-4 p-2 text-center font-mono text-xs">
          The page you are looking for does not exist.
        </p>
        <Button type="button" size="sm" variant="secondary" asChild>
          <Link to="/"> Go to Home</Link>
        </Button>
      </main>
      <footer className="flex items-center justify-center py-6">
        <p className="text-muted-foreground mx-auto text-center text-xs">
          &copy; {new Date().getFullYear()}
        </p>
      </footer>
    </div>
  )
}
